import { AvailableTypographyClasses } from "@/types/Typography";
import React, { createContext, useContext, useState, ReactNode } from "react";
type ThemeName = "dark" | "light";

const defaultColors = {
  gold: "rgba(232,176,139,1)",
  lightGold: "rgba(232,176,139,0.5)",
  lightGray: "#ACB0B9",
  darkGray: "#7C7D7E",
  black: "#312F30",
  white: "#FFF4E9",
};

const colors = {
  dark: {
    background: defaultColors.black,
    buttons: {
      default: {
        background: defaultColors.white,
        text: defaultColors.black,
        border: "transparent",
      },
    },
    text: defaultColors.white,
    heading: defaultColors.white,
    link: defaultColors.white,
    border: defaultColors.gold,
    highlight: defaultColors.gold,
    divider: defaultColors.lightGold,
  },
  light: {
    background: defaultColors.white,
    buttons: {
      default: {
        background: defaultColors.darkGray,
        text: defaultColors.black,
        border: defaultColors.black,
      },
    },
    text: defaultColors.black,
    heading: defaultColors.black,
    link: defaultColors.black,
    border: defaultColors.black,
    highlight: defaultColors.black,
    divider: defaultColors.lightGold,
  },
};

const typographyClasses: {
  [key: string]: {
    className: AvailableTypographyClasses;
  };
} = {
  h1: {
    className: "italiana-regular",
  },
  h2: {
    className: "italiana-regular",
  },
  h3: {
    className: "italiana-regular",
  },
  h4: {
    className: "italiana-regular",
  },
  h5: {
    className: "italiana-regular",
  },
  h6: {
    className: "italiana-regular",
  },
  p: {
    className: "mulish-regular",
  },
  span: {
    className: "mulish-regular",
  },
  a: {
    className: "mulish-regular",
  },
};

type StyleContextType = {
  theme: ThemeName;
  setTheme: (Style: ThemeName) => void;
  colors: typeof colors;
  typographyClasses: typeof typographyClasses;
};

const StyleContext = createContext<StyleContextType | undefined>(undefined);

export const StyleProvider = ({ children }: { children: ReactNode }) => {
  const [theme, setTheme] = useState<ThemeName>("dark");

  return (
    <StyleContext.Provider
      value={{ theme, setTheme, colors, typographyClasses }}
    >
      {children}
    </StyleContext.Provider>
  );
};

export const useStyle = (): StyleContextType => {
  const context = useContext(StyleContext);
  if (!context) {
    throw new Error("useStyle must be used within a StyleProvider");
  }
  return context;
};
